(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabinet-collection-banner-ctm"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.product-display-ctm__thumbnail');
  const mainImages = document.querySelectorAll('.product-display-ctm__main-image');
  const gallery = document.querySelector('.product-display-ctm__thumbnail-gallery');
  const leftButton = document.querySelector('.product-display-ctm__scroll-button--left');
  const rightButton = document.querySelector('.product-display-ctm__scroll-button--right');
  const mainImageWrapper = document.querySelector('.product-display-ctm__main-image-wrapper');
  
  function initMobileGallery() {
    if (window.innerWidth <= 576 && mainImages.length > 1) {
      let dotsContainer = document.querySelector('.product-display-ctm__dots');
      if (!dotsContainer) {
        dotsContainer = document.createElement('div');
        dotsContainer.className = 'product-display-ctm__dots';
        
        mainImages.forEach((_, index) => {
          const dot = document.createElement('div');
          dot.className = `product-display-ctm__dot ${index === 0 ? 'active' : ''}`;
          dot.dataset.index = index;
          dotsContainer.appendChild(dot);
        });
        
        mainImageWrapper.appendChild(dotsContainer);
      } else {
        dotsContainer.style.display = 'flex';
      }
      
      document.querySelectorAll('.product-display-ctm__dot').forEach(dot => {
        dot.addEventListener('click', function() {
          const index = this.dataset.index;
          updateActiveImage(index);
        });
      });
      
      initTouchEvents();
    } else {
      const dotsContainer = document.querySelector('.product-display-ctm__dots');
      if (dotsContainer) {
        dotsContainer.style.display = 'none';
      }
    }
  }
  
  function initTouchEvents() {
    if (window.innerWidth > 576) return;
    
    let touchStartX = 0;
    let touchEndX = 0;
    const threshold = 50; 
    let currentIndex = 0;
    
    mainImageWrapper.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, {passive: true});
    
    mainImageWrapper.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, {passive: true});
    
    function handleSwipe() {
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) < threshold) return;
      
      if (diff > 0) {
        currentIndex = (currentIndex + 1) % mainImages.length;
      } else {
        currentIndex = (currentIndex - 1 + mainImages.length) % mainImages.length;
      }
      
      updateActiveImage(currentIndex);
    }
  }

  function updateActiveImage(index) {
    mainImages.forEach(img => img.classList.add('hidden'));
    const selectedImage = document.querySelector(`.product-display-ctm__main-image[data-index="${index}"]`);
    if (selectedImage) {
      selectedImage.classList.remove('hidden');
    }
    
    if (thumbnails.length) {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumbnails[index].classList.add('active');
    }
    
    const dots = document.querySelectorAll('.product-display-ctm__dot');
    if (dots.length) {
      dots.forEach(d => d.classList.remove('active'));
      dots[index].classList.add('active');
    }
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      updateActiveImage(index);
    });
  });

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('product-display-ctm__dot')) {
      const index = e.target.dataset.index;
      updateActiveImage(index);
    }
  });

  if (gallery && leftButton && rightButton) {
    const scrollAmount = 200;
    const isVertical = window.getComputedStyle(gallery).flexDirection === 'column';
    
    leftButton.addEventListener('click', () => {
      if (isVertical) {
        gallery.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
      } else {
        gallery.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      }
    });
    
    rightButton.addEventListener('click', () => {
      if (isVertical) {
        gallery.scrollBy({ top: scrollAmount, behavior: 'smooth' });
      } else {
        gallery.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });
    
    function updateScrollButtons() {
      if (isVertical) {
        const canScrollUp = gallery.scrollTop > 0;
        const canScrollDown = gallery.scrollTop < (gallery.scrollHeight - gallery.clientHeight);
        leftButton.style.display = canScrollUp ? 'flex' : 'none';
        rightButton.style.display = canScrollDown ? 'flex' : 'none';
      } else {
        const canScrollLeft = gallery.scrollLeft > 0;
        const canScrollRight = gallery.scrollLeft < (gallery.scrollWidth - gallery.clientWidth);
        leftButton.style.display = canScrollLeft ? 'flex' : 'none';
        rightButton.style.display = canScrollRight ? 'flex' : 'none';
      }
    }
    
    gallery.addEventListener('scroll', updateScrollButtons);
    window.addEventListener('resize', updateScrollButtons);
    updateScrollButtons();
  }
  
  initMobileGallery();
  
  window.addEventListener('resize', function() {
    initMobileGallery();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ctm-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-offcanvas"] && !Shopify.designMode) return;
  try {
    
      document.addEventListener('DOMContentLoaded', function() {
    if (typeof google === 'object' && typeof google.maps === 'object') {
      initAutocomplete();
    } else {
      window.initAutocomplete = initAutocomplete;
    }
  });
  function initAutocomplete() {
  googleAutocomplete = {
      autocompleteField: function(fieldId) {
          var options = {
              types: ["geocode"],
              componentRestrictions: { country: "US" }
          };

          var input = document.getElementById('address');
          var autocomplete = new google.maps.places.Autocomplete(
              document.getElementById(fieldId),
              options
          );

          // Store the latitude and longitude of the searched location
          var searchLat, searchLng;

          const placesService = new google.maps.places.PlacesService(document.createElement('div'));

              // Add listener for the place_changed event
              autocomplete.addListener('place_changed', onPlaceChanged);

              // Add listener for the keydown event to handle Enter key
              input.addEventListener('keydown', function(event) {
                  if (event.key === 'Enter') {
                      event.preventDefault();
                      getFirstSuggestion(input.value);
                  }
              });

          function getFirstSuggestion(input) {
              const service = new google.maps.places.AutocompleteService();
              service.getPlacePredictions({ input: input }, function(predictions, status) {
                  if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
                      const placeId = predictions[0].place_id;
                      placesService.getDetails({ placeId: placeId }, function(place, status) {
                          if (status === google.maps.places.PlacesServiceStatus.OK) {
                              onPlaceSelected(place);
                          }
                      });
                  } else {
                      console.log("No predictions available");
                  }
              });
          }

          function onPlaceSelected(place) {

              if (!place.geometry) {
                  // console.log("No place details available for the input: '" + place.name + "'");
                  return;
              }

              const searchLat = place.geometry.location.lat();
              const searchLng = place.geometry.location.lng();

              // Initialize array to store distances and corresponding store divs
              const storeDistances = [];

              // Loop through each store div
              const storeDivs = document.querySelectorAll('.aaa-store-details');
              storeDivs.forEach(function(storeDiv) {
                  const storeLat = parseFloat(storeDiv.dataset.lattitude);
                  const storeLng = parseFloat(storeDiv.dataset.longitude);

                  // Calculate distance using Haversine formula
                  const distance = getDistanceFromLatLonInMiles(searchLat, searchLng, storeLat, storeLng);

                  // Update the distance in the respective store div
                  const distanceElement = storeDiv.querySelector('.distance-matrix h2');
                  distanceElement.textContent = distance.toFixed(2) + " mi";

                  // Push an object with store div and distance to array
                  storeDistances.push({ div: storeDiv, distance: distance });
              });

              // Sort the store divs based on distance
              storeDistances.sort(function(a, b) {
                  return a.distance - b.distance;
              });

              // Apply new order based on sorted distances
              storeDistances.forEach(function(store, index) {
                  store.div.style.order = index + 1;
              });
          }

          // Event listener for place_changed
          function onPlaceChanged() {
              const place = autocomplete.getPlace();
              if (!place.geometry) {
                  // console.log("No place details available for the input: '" + place.name + "'");
                  return;
              }
              onPlaceSelected(place);
          }

          // Optionally, if you need an input event listener, it can be combined or kept separate
          document.getElementById("address").addEventListener("input", function() {
              if (!searchLat || !searchLng) {
                  // console.log("Please select a location firsttttttttttt.");
              }
          });

      }
  };
  googleAutocomplete.autocompleteField("address");
  }

  // Function to calculate distance between two points using Haversine formula
  function getDistanceFromLatLonInMiles(lat1, lon1, lat2, lon2) {
      var R = 3958.8; // Radius of the Earth in miles
      var dLat = deg2rad(lat2 - lat1);
      var dLon = deg2rad(lon2 - lon1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in miles
      return d;
  }

  function deg2rad(deg) {
      return deg * (Math.PI / 180);
  }

  } catch(e) { console.error(e); }
})();
})();
